import { Type, Exclude, Expose } from "class-transformer";
import { Expenditure, Investment, Locality, Person, Product, SimpleCost, Unimi } from "./Decoding";
import md5 from "crypto-js/md5";
import { PROD_INVESTS, YOUNG_FARMER } from "./Form";
import { Utils } from "../Utils";
import { INPROGRESS,RECEIVED,SUBMITTED,UNDER_EVALUATION,NEEDS_DIGITISION,FURTHER_DIGITISING_INFO,DIGITISING_COMPLETE,
        PSC_CLARIFICATION,CLARIFICATION_EXPIRED,REPLY_TO_CLARIFICATION,READY_FOR_RANKING,CAPTURED_IN_RANKING,
        SELECTED,FAILED_SELECTION,REJECTED,APPEAL,APPEAL_REJECTED,WITHDRAW,CONTRACT,ADMINISTRATIVE_CORRECTION,EXPIRED,
        ADDENDUM_SIGNED, CR_WITHDRAWN, BN_TO_RE_SUBMIT_THE_REQUEST, FOR_INTERNAL_REVIEW, NO_CR_WAS_NECESSARY, TO_ISSUE_CRRB_DECISION_LETTER,
        CR_TO_BE_SUPERSEDED, DECISION_TAKEN_NOTIFICATION_ACKNOWLEDGED, REQUEST_FOR_CLARIFICATIONS_SENT_PRIOR_TO_CRRB, REQUEST_FOR_CLARIFICATIONS_SENT_POST_CRRB,
        CLARIFICATION_RECEIVED, AT_PSC_FOR_REVIEW, DECISION_TAKEN_APPROVED, DECISION_TAKEN_PARTIALLY_APPROVED, DECISION_TAKEN_NOT_APPROVED

 } from "./Contract";
 
 export interface DecisionLetterDTO {
  available: boolean;
  status: string;
  decisionDescription: string;
  clientFeedback: string;
  decisionFileId: number;
  appealAllowed: true;
  appealExpiryDate: string;
}

export interface DecisionLetterAppeal {
  reason: string;
}


 export interface QuestionAnswer {
    pkidQuestion: number;
    clarificationId: number;
    cpDescription: string;
    cpQuestion: string;
    cpAnswer: string | null;
    numberOfDays: number;
    daysRemaining: number;
    status: string;
}

export interface PscClarification {
    questionAnswersList: QuestionAnswer[];
    days_remaining: number;
}
export interface EditablePscSection {
  editableMap: Record<string, boolean>;
}
export class EditablePscState {
  static editableMap: Record<string, boolean> = {};
}
export interface ProjectProposalPaths {
    pageCode: string;
    title: string;
    code: string;
    complete: boolean;
    editable: boolean;
    editableDesc: string;
    formType: string;
    documentCode: string;
    fileUpload: boolean;
}

export class ProjectProposal {
    application_id!: number;
    call!: number;
    description!: string;
    newSentence!: string;
    batch_title_shown!: string;
    title!: string;
    intervention!: string;
    print_flag!: string;
    module_id!: number;
    module_code!: string;
    programme!: string;
    app_status!: string;
    application_status_code!: string;//status_code
    //status_code!: string;
    contract_status!: string;//sco_stato
    subject_name!: string;
    sections!: ProjectProposalPaths[];
    can_edit!: boolean;
    dynamicForm!: boolean;
    cod_modu!: string;
    application_status_description!: string;//status
    decision_letter_option!: string;
    toString(): string {
        return `${this.intervention} | ${this.title} | ${Math.abs(this.application_id)} | ${this.description}`;
    }

    @Exclude()
    get isYoungFarmer(): boolean {
        return this.module_code.includes(YOUNG_FARMER);
    }

    @Exclude()
    get isProdInvests(): boolean {
        return this.module_code.includes(PROD_INVESTS);
    }

    @Exclude()

   
    get getStatus(): string {
        switch (this.application_status_code) {
            case INPROGRESS:
            case RECEIVED:
            case SUBMITTED:
            case UNDER_EVALUATION:
            case NEEDS_DIGITISION:
            case FURTHER_DIGITISING_INFO:
            case DIGITISING_COMPLETE:
            case PSC_CLARIFICATION:
            case CLARIFICATION_EXPIRED:
            case REPLY_TO_CLARIFICATION:
            case READY_FOR_RANKING:
            case CAPTURED_IN_RANKING:
            case FAILED_SELECTION:
            case SELECTED:
            case REJECTED:
            case APPEAL:
            case APPEAL_REJECTED:
            case WITHDRAW:
            case CONTRACT:
            case ADMINISTRATIVE_CORRECTION:
            case EXPIRED:
            case ADDENDUM_SIGNED:
            case CR_WITHDRAWN:
            case BN_TO_RE_SUBMIT_THE_REQUEST:
            case FOR_INTERNAL_REVIEW:
            case NO_CR_WAS_NECESSARY:
            case TO_ISSUE_CRRB_DECISION_LETTER:
            case CR_TO_BE_SUPERSEDED:
            case DECISION_TAKEN_NOTIFICATION_ACKNOWLEDGED:
            case REQUEST_FOR_CLARIFICATIONS_SENT_PRIOR_TO_CRRB:
            case REQUEST_FOR_CLARIFICATIONS_SENT_POST_CRRB:
            case CLARIFICATION_RECEIVED:
            case AT_PSC_FOR_REVIEW:
            case DECISION_TAKEN_APPROVED:
            case DECISION_TAKEN_PARTIALLY_APPROVED:
            case DECISION_TAKEN_NOT_APPROVED:
                return this.application_status_code;
            
            default:
                return INPROGRESS;
        }
    }

    @Exclude()

    get appStatus(): string {
        const scoStatoMapping: Record<string, string> = {
            "000010": "DRAFT",               //  status when Draft
            "000020": "SIGNED",              //  status when SIGNED
            "000030": "SIGNED",              //  status when Addendum
            "ESTEND": "SIGNED",              //  status when Extend Dates
            "CESTEN": "SIGNED",              //  status when Register Extension
            "000080": "MA Terminated",       //  status when MA Terminated
            "000090": "BN Withdrawal",       //  status when BN Withdrawal
            "000070": "Project Closed",      //  status when Project Closed / Success Close
            "CLOFUL": "Project Closed",      //  status when Project Closed / Closed with full recovery
            "CLOREC": "Project Closed",      //  status when Project Closed / Closed with recovery
            "ZERCLA": "Project Closed"       //  status when Project Closed / Closed with Zero Claim
        };

        //if (this.cod_modu && this.cod_modu.startsWith("CSP")) {
            switch (this.getStatus) {
                case INPROGRESS:
                    return "DRAFT";
                case RECEIVED:
                    return "RECEIVED";
                case SUBMITTED:
                    return "SUBMITTED";
                case UNDER_EVALUATION:
                case NEEDS_DIGITISION:
                case FURTHER_DIGITISING_INFO:
                case DIGITISING_COMPLETE:
                case READY_FOR_RANKING:
                case CAPTURED_IN_RANKING:
                case SELECTED:
                case REJECTED:
                case FAILED_SELECTION:
                    return "UNDER EVALUATION";
                case PSC_CLARIFICATION:
                    return "PSC CLARIFICATION";
                case CLARIFICATION_EXPIRED:
                    return "CLARIFICATION EXPIRED";
                case REPLY_TO_CLARIFICATION:
                    return "CLARIFICATION SUBMITTED";
                case APPEAL:
                    return "APPEAL SUBMITTED";
                case APPEAL_REJECTED:
                    return "APPEAL REJECTED";
                case WITHDRAW:
                    return "APPLICATION WITHDRAWN";
                case ADMINISTRATIVE_CORRECTION:
                    return "CONTRACTED";
                case EXPIRED:
                    return "EXPIRED";
            case CONTRACT:
                if (this.contract_status && scoStatoMapping[this.contract_status]) {
                    return scoStatoMapping[this.contract_status];
                }

                if (this.decision_letter_option === "000001") {
                    return "AWARDED";
                } else if (this.decision_letter_option === "000002") {
                    return "CONDITIONAL AWARDED";
                } else if (this.decision_letter_option === "000003") {
                    return "AWARDED - RESERVE LIST";
                }

                return "CONTRACTED";

                
               case CR_WITHDRAWN:
                    return "CR WITHDRAWN";
                case ADDENDUM_SIGNED:
                    return "ADDENDUM SIGNED";
                case BN_TO_RE_SUBMIT_THE_REQUEST:
                    return "BN TO RE-SUBMIT THE REQUEST";
                case FOR_INTERNAL_REVIEW:
                    return "FOR INTERNAL REVIEW";
                case NO_CR_WAS_NECESSARY:
                    return "NO CR WAS NECESSARY";
                case TO_ISSUE_CRRB_DECISION_LETTER:
                    return "TO ISSUE CRRB DECISION LETTER";
                case CR_TO_BE_SUPERSEDED:
                    return "CR TO BE SUPERSEDED";
                case DECISION_TAKEN_NOTIFICATION_ACKNOWLEDGED:
                    return "DECISION TAKEN - NOTIFICATION ACKNOWLEDGED";
                case REQUEST_FOR_CLARIFICATIONS_SENT_PRIOR_TO_CRRB:
                    return "REQUEST FOR CLARIFICATIONS SENT PRIOR TO CRRB";
                case REQUEST_FOR_CLARIFICATIONS_SENT_POST_CRRB:
                    return "REQUEST FOR CLARIFICATIONS SENT POST CRRB";
                case CLARIFICATION_RECEIVED:
                    return "CLARIFICATION RECEIVED";
                case AT_PSC_FOR_REVIEW:
                    return "AT PSC FOR REVIEW";
                case DECISION_TAKEN_APPROVED:
                    return "DECISION TAKEN - APPROVED";
                case DECISION_TAKEN_PARTIALLY_APPROVED:
                    return "DECISION TAKEN - PARTIALLY APPROVED";
                case DECISION_TAKEN_NOT_APPROVED:
                    return "DECISION TAKEN - NOT APPROVED";


                default:
                    return this.application_status_description;
            }
        // } else {
        //    return this.status;
        // }
    }

}

export class Measure {
    call!: number;
    deadline!: number;
    description!: string;
    intervention!: string;
    moduleId!: number;
    moduleCode!: string;
    programme!: string;
    messages!: string;
    disclaimer!: string;

    @Exclude()
    get disabled(): boolean {
        return !!this.messages;
    }
}

export class Measures {
    @Type(() => Measure)
    measures: Measure[] = [];
}

export class Quotation {
    item_id!: number;
    application_id!: number;
    subject_id!: number;
    quotation_id!: number;
    quotation: string | null = null;
    net_amount: number | null = null;
    vat_amount: number | null = null;
    tot_amount: number | null = null;
    um_code: string | null = null;
    um_sub_code: string | null = null;
    um_description: string | null = null;
    simple_cost_code: string | null = null;
    simple_cost_sub_code: string | null = null;
    simple_cost_description: string | null = null;
    simple_cost_value: string | null = null;
    simple_cost_formula: string | null = null;
    simple_cost_unit: string | null = null;
    quantity: number | null = null;

    @Exclude()
    private _touched = false;

    @Exclude()
    set touched(value: boolean) {
        this._touched = value;
    }

    @Exclude()
    set umimis(umimis: Unimi | null) {
        if (umimis) {
            this.um_code = umimis.unimis_code;
            this.um_sub_code = umimis.unimis_sub_code;
            this.um_description = umimis.unimis_description;
        } else {
            this.um_code = null;
            this.um_sub_code = null;
            this.um_description = null;
        }
    }

    @Exclude()
    set simpleCost(simpleCost: SimpleCost | null) {
        if (simpleCost) {
            this.simple_cost_code = simpleCost.simple_cost_code;
            this.simple_cost_sub_code = simpleCost.simple_cost_sub_code;
            this.simple_cost_description = simpleCost.simple_cost_description;
            this.simple_cost_formula = simpleCost.simple_cost_formula;
            this.simple_cost_unit = simpleCost.simple_cost_unit;
            if (this.quantity) {
                if (simpleCost.simple_cost_formula)
                    // this.net_amount = eval(
                    //     simpleCost.simple_cost_formula.replace("{VALORE}", this.quantity.toString())
                    // );
                    this.net_amount = Number(simpleCost.simple_cost_formula) * this.quantity;
                if (this.net_amount !== null) this.vat_amount = this.net_amount * simpleCost.simple_cost_vat_percentage;
            }
        } else {
            this.simple_cost_code = null;
            this.simple_cost_sub_code = null;
            this.simple_cost_description = null;
            this.simple_cost_formula = null;
            this.simple_cost_unit = null;
        }
    }

    @Exclude()
    get isValid(): string[] {
        const ret: string[] = [];
        typeof this.quotation !== "string" && ret.push("quotation");
        (typeof this.vat_amount !== "number" || (typeof this.vat_amount === "number" && this.vat_amount < 0)) &&
            ret.push("eligible_vat_amount");
        (typeof this.net_amount !== "number" || (typeof this.net_amount === "number" && this.net_amount < 0)) &&
            ret.push("eligible_net_amount");
        return this._touched ? ret : [];
    }
}

export class LineItem {
    application_id!: number;
    subject_id!: number;
    item_id!: number;
    action_id!: number;
    net_amount: number | null = null;
    vat_amount: number | null = null;
    eligible_net_amount: number | null = null;
    eligible_vat_amount: number | null = null;
    saved_amount: number | null = null;
    trasf_saved_amount: number | null = null;
    payed_amount: number | null = null;
    notes: string | null = null;
    fg_approved: string | null = null;
    fkid_folder: number | null = null;

    action_description: string | null = null;

    // activity refers to "Type to expenditure"
    activity_code: string | null = null;
    activity_sub_code: string | null = null;
    activity_description: string | null = null;
    activity_simple_cost: number | null = null;
    activity_visible_locality: number | null = null;

    proposal_code: string | null = null;
    proposal_sub_code: string | null = null;
    proposal_description: string | null = null;

    istat_comune: string | null = null;
    istat_provincia: string | null = null;
    locality_description: string | null = null;
    item_description: string | null = null;
    id_category: string | null = null;
    id_investment: string | null = null;
    type_of_investment: string | null = null;

    component: string | null = null;
    @Type(() => Quotation)
    quotations: Quotation[] = [];

    @Exclude({ toPlainOnly: true })
    private _edited = false;

    @Exclude()
    private _touched = false;


    @Exclude()
    set touched(value: boolean) {
        this._touched = value;
    }

    set edited(edited: boolean) {
        this._edited = edited;
    }

    @Expose()
    get edited(): boolean {
        if (this._edited) {
            return true;
        }
        const hash = LineItem.toHash(this);
        return this.hash !== hash;
    }

    @Exclude({ toPlainOnly: true })
    hash!: string;

    @Exclude()
    set activity(activity: Expenditure | Investment | null) {
        if (activity) {
            if (activity instanceof Expenditure) {
                this.activity_code = activity.expenditure_code;
                this.activity_sub_code = activity.expenditure_sub_code;
                this.activity_description = activity.expenditure_description;
            } else if (activity instanceof Investment) {
                this.activity_code = activity.investment_code;
                this.activity_sub_code = activity.investment_sub_code;
                this.activity_description = activity.investment_description;
                this.activity_simple_cost = activity.investment_simple_cost;
                this.activity_visible_locality = activity.investment_visible_locality;
            }
        } else {
            this.activity_code = null;
            this.activity_sub_code = null;
            this.activity_description = null;
            this.activity_simple_cost = null;
            this.activity_visible_locality = null;
        }
    }

    @Exclude()
    set locality(locality: Locality | null) {
        if (locality) {
            this.istat_comune = locality.istat_comune;
            this.istat_provincia = locality.istat_provincia;
            this.locality_description = locality.locality_description;
        } else {
            this.istat_comune = null;
            this.istat_provincia = null;
            this.locality_description = null;
        }
    }

    @Exclude()
    static toHash({
        notes,
        eligible_vat_amount,
        eligible_net_amount,
        component,
        activity_description,
        action_description,
        activity_code,
        activity_simple_cost,
        activity_visible_locality,
        quotations: quotationsItems
    }: LineItem): string {
        const quotations = quotationsItems.map(
            ({ vat_amount, net_amount, quantity, um_code, um_sub_code, um_description, quotation }) => {
                return {
                    notes,
                    eligible_vat_amount,
                    eligible_net_amount,
                    vat_amount,
                    net_amount,
                    quantity,
                    um_code,
                    um_sub_code,
                    um_description,
                    quotation
                };
            }
        );

        const asString = JSON.stringify({
            notes,
            eligible_vat_amount,
            eligible_net_amount,
            component,
            activity_description,
            action_description,
            activity_code,
            activity_simple_cost,
            activity_visible_locality,
            quotations
        });
        return md5(asString).toString();
    }

    @Exclude()
    get isValid(): string[] {
        const isValid = this._touched
            ? this.quotations.map((q, i) => q.isValid.map(e => `quotations.${i}.${e}`)).flat()
            : [];
        const ret = [...isValid];

        return ret;
    }

    @Exclude()
    get totNetAmount(): number {
        return Utils.sum(this.quotations.map(e => e.net_amount || 0));
    }

    @Exclude()
    get totVatAmount(): number {
        return Utils.sum(this.quotations.map(e => e.vat_amount || 0));
    }

    @Exclude()
    get totAmount(): number {
        return Utils.sum(this.quotations.map(e => e.tot_amount || 0));
    }

    @Exclude()
    get isSimpleCost(): boolean {
        return !!this.activity_simple_cost;
    }

    @Exclude()
    get isVisibleLocality(): boolean {
        return !!this.activity_visible_locality;
    }
}

export class LineItems {
    @Type(() => LineItem)
    lineItems: LineItem[] = [];

    @Exclude()
    get isValid(): string[] {
        const isValid = this.lineItems.map((q, i) => q.isValid.map(e => `lineItems.${i}.${e}`)).flat();
        return [...isValid];
    }

    @Exclude()
    get totNetAmount(): number {
        return Utils.sum(this.lineItems.map(e => e.totNetAmount));
    }

    @Exclude()
    get totVatAmount(): number {
        return Utils.sum(this.lineItems.map(e => e.totVatAmount));
    }

    @Exclude()
    get totAmount(): number {
        return Utils.sum(this.lineItems.map(e => e.totAmount));
    }
}

export class ProjectProposalDetails {
    id_domanda!: number;
    id_project_detail!: number;
    title!: string;
    duration!: number;
    natura_giuridica!: string | null;
    id_category!: number | null;
    dt_insert!: number;
    dt_delete!: number;
    young_farmer_number!: string;
    applicant_name!: string | null;
    applicant_surname!: string | null;
    applicant_id_number!: string | null;
    applicant_address1!: string | null;
    applicant_address2!: string | null;
    applicant_address3!: string | null;
    applicant_city!: string | null;
    applicant_locality_description!: string | null;
    applicant_mobile!: string | null;
    applicant_mail!: string | null;
    applicant_website!: string | null;
    leader_title!: string | null;
    leader_name!: string | null;
    leader_surname!: string | null;
    leader_id_number!: string | null;
    leader_mobile!: string | null;
    leader_mail!: string | null;
    leader_position!: string | null;
    partnership_sotto_codice!: string | null;
    partnership_other!: string | null;
    vat_status_number!: string;
    vat_status_recover_flag!: string;
    contact_person_sotto_codice!: string;
    contact_person_other_sotto_codice!: string | null;
    contact_person_title!: string | null;
    contact_person_name!: string | null;
    contact_person_surname!: string | null;
    contact_person_id_number!: string | null;
    contact_person_address1!: string | null;
    contact_person_address2!: string | null;
    contact_person_address3!: string | null;
    contact_person_mobile!: string | null;
    contact_person_mail!: string | null;
    gender!: string | null;

    @Exclude()
    set applicant(person: Person | null) {
        if (person) {
            this.applicant_name = person.name;
            this.applicant_surname = person.surname;
            this.applicant_id_number = person.fiscal_code;
            this.applicant_address1 = person.address;
            this.applicant_address2 = person.address2;
            this.applicant_address3 = person.address3;
            this.applicant_mail = person.email_address;
            this.applicant_mobile = person.mobile_number;
            this.applicant_website = person.website;
            this.applicant_city = person.cod_belf_residenza;
            this.applicant_locality_description = person.locality_description;
        } else {
            this.applicant_name = null;
            this.applicant_surname = null;
            this.applicant_id_number = null;
            this.applicant_address1 = null;
            this.applicant_address2 = null;
            this.applicant_address3 = null;
            this.applicant_city = null;
            this.applicant_mobile = null;
            this.applicant_mail = null;
            this.applicant_website = null;
            this.applicant_city = null;
            this.applicant_locality_description = null;
        }
    }

    get applicant() {
        const person: Person = new Person();
        person.name = this.applicant_name;
        person.surname = this.applicant_surname;
        person.fiscal_code = this.applicant_id_number;
        person.address = this.applicant_address1;
        person.address2 = this.applicant_address2;
        person.address3 = this.applicant_address3;
        person.email_address = this.applicant_mail;
        person.mobile_number = this.applicant_mobile;
        return person;
    }

    get isEmptyApplicantForLeader() {
        return !this.applicant_name && !this.applicant_surname && !this.applicant_mobile && !this.applicant_mail;
    }

    @Exclude()
    set leader(person: Person | null) {
        if (person) {
            this.leader_name = person.name;
            this.leader_surname = person.surname;
            this.leader_id_number = person.fiscal_code;
            this.leader_mobile = person.mobile_number;
            this.leader_mail = person.email_address;
            this.leader_position = person.position_sotto_codice;
        } else {
            this.leader_title = null;
            this.leader_name = null;
            this.leader_surname = null;
            this.leader_id_number = null;
            this.leader_mobile = null;
            this.leader_mail = null;
            this.leader_position = null;
        }
    }

    get leader() {
        const person: Person = new Person();
        person.title = this.leader_title;
        person.name = this.leader_name;
        person.surname = this.leader_surname;
        person.fiscal_code = this.leader_id_number;
        person.email_address = this.leader_mail;
        person.mobile_number = this.leader_mobile;
        return person;
    }

    get isEmptyLeader() {
        return (
            !this.leader_name &&
            !this.leader_surname &&
            !this.leader_id_number &&
            !this.leader_mobile &&
            !this.leader_mail &&
            !this.leader_position
        );
    }

    @Exclude()
    set contact(person: Person | null) {
        if (person) {
            this.contact_person_title = person.title;
            this.contact_person_name = person.name;
            this.contact_person_surname = person.surname;
            this.contact_person_address1 = person.address;
            this.contact_person_address2 = person.address2;
            this.contact_person_address3 = person.address3;
            this.contact_person_id_number = person.fiscal_code;
            this.contact_person_mobile = person.mobile_number;
            this.contact_person_mail = person.email_address;
        } else {
            this.contact_person_title = null;
            this.contact_person_name = null;
            this.contact_person_surname = null;
            this.contact_person_address1 = null;
            this.contact_person_address2 = null;
            this.contact_person_address3 = null;
            this.contact_person_id_number = null;
            this.contact_person_mobile = null;
            this.contact_person_mail = null;
        }
    }

    get contact() {
        const person: Person = new Person();
        person.name = this.contact_person_name;
        person.surname = this.contact_person_surname;
        person.fiscal_code = this.contact_person_id_number;
        person.address = this.contact_person_address1;
        person.email_address = this.contact_person_mail;
        person.mobile_number = this.contact_person_mobile;
        return person;
    }

    get isEmptyContact() {
        return (
            !this.contact_person_title &&
            !this.contact_person_name &&
            !this.contact_person_surname &&
            !this.contact_person_address1 &&
            !this.contact_person_address2 &&
            !this.contact_person_address3 &&
            !this.contact_person_id_number &&
            !this.contact_person_mobile &&
            !this.contact_person_mail
        );
    }

    @Exclude()
    set locality(locality: Locality | null) {
        if (locality) {
            this.applicant_city = locality.codi_fisc_luna;
            this.applicant_locality_description = locality.locality_description;
        } else {
            this.applicant_city = null;
            this.applicant_locality_description = null;
        }
    }

    @Exclude()
    isValid(contract: ProjectProposal | null, sections: DetailSections | null): string[] {
        const ret: string[] = [];
        //const maxDuration = 24;
        const maxDuration = Number(sections?.duration_in_months_number);
        (!this.title || this.title.trim() === "") && ret.push("title");
        (!this.duration || this.duration > maxDuration) && ret.push("duration");
        // if (sections?.flg_section_04) {
        //     (!this.applicant_mobile || this.applicant_mobile?.trim() === "") && ret.push("applicant_mobile");
        //     (!this.applicant_mail || !Utils.validateEmail(this.applicant_mail)) && ret.push("applicant_mail");
        // }
        if (sections?.flg_section_07) {
            (!this.leader_mobile || this.leader_mobile?.trim() === "") && ret.push("leader_mobile");
            (!this.leader_mail || !Utils.validateEmail(this.leader_mail)) && ret.push("leader_mail");
        }
        if (sections?.flg_section_08) {
            (!this.contact_person_mobile || this.contact_person_mobile?.trim() === "") &&
                ret.push("contact_person_mobile");
            (!this.contact_person_mail || !Utils.validateEmail(this.contact_person_mail)) &&
                ret.push("contact_person_mail");
        }

        return ret;
    }
}

export class DetailSections {
    id_modulo!: number;
    flg_section_01!: boolean;
    flg_section_02!: boolean;
    flg_section_03!: boolean;
    flg_section_04!: boolean;
    flg_section_05!: boolean;
    flg_section_06!: boolean;
    flg_section_07!: boolean;
    flg_section_08!: boolean;
    tip_duration!: string;
    duration_in_months_number!: string;
}

export class StandardOutput {
    application_id!: number;
    standard_output_id!: number;
    id_soggetto!: number;
    year!: number | null;
    region!: string | null;
    region_name!: string | null;
    field_id!: string | null;
    unit!: string | null;
    agricultural_product!: string | null;
    coefficient!: number | null;
    num_economic_size!: number | null;
    so_value!: number | null;
    cod_fonte_dati!: string | null;
    sco_fonte_dati!: string | null;
    dt_inizio!: number;
    dt_fine!: number;
    fg_valido_inizio!: string | null;
    fg_valido_fine!: string | null;
    id_atto_inizio!: number | null;
    id_atto_fine!: number | null;
    dt_ultimo_agg!: number | null;
    utente!: string | null;

    @Exclude({ toPlainOnly: true })
    private _edited = false;

    @Exclude()
    private _touched = false;

    @Exclude()
    set touched(value: boolean) {
        this._touched = value;
    }

    set edited(edited: boolean) {
        this._edited = edited;
    }

    @Expose()
    get edited(): boolean {
        if (this._edited) {
            return true;
        }
        const hash = StandardOutput.toHash(this);
        return this.hash !== hash;
    }

    @Exclude({ toPlainOnly: true })
    hash!: string;

    @Exclude()
    static toHash({
        region_name,
        agricultural_product,
        coefficient,
        num_economic_size,
        so_value
    }: StandardOutput): string {
        const asString = JSON.stringify({
            region_name,
            agricultural_product,
            coefficient,
            num_economic_size,
            so_value
        });
        return md5(asString).toString();
    }

    @Exclude()
    get isValid(): string[] {
        return [];
    }

    @Exclude()
    set product(product: Product | null) {
        if (product) {
            this.year = product.year;
            this.region = product.region;
            this.region_name = product.region_name;
            this.field_id = product.field_id;
            this.unit = product.unit;
            this.agricultural_product = product.agricultural_product;
            this.coefficient = product.coefficient;
            this.cod_fonte_dati = product.cod_fonte_dati;
            this.sco_fonte_dati = product.sco_fonte_dati;
            this.fg_valido_inizio = product.fg_valido_inizio;
            this.fg_valido_fine = product.fg_valido_fine;
            this.id_atto_inizio = product.id_atto_inizio;
            this.id_atto_fine = product.id_atto_fine;
            this.dt_ultimo_agg = product.dt_ultimo_agg;
            this.utente = product.utente;
        } else {
            this.year = null;
            this.region = null;
            this.region_name = null;
            this.field_id = null;
            this.unit = null;
            this.agricultural_product = null;
            this.coefficient = null;
            this.cod_fonte_dati = null;
            this.sco_fonte_dati = null;
            this.fg_valido_inizio = null;
            this.fg_valido_fine = null;
            this.id_atto_inizio = null;
            this.id_atto_fine = null;
            this.dt_ultimo_agg = null;
            this.utente = null;
        }
    }

    get product() {
        const product: Product = new Product();
        product.year = this.year;
        product.region = this.region;
        product.region_name = this.region_name;
        product.field_id = this.field_id;
        product.unit = this.unit;
        product.agricultural_product = this.agricultural_product;
        product.coefficient = this.coefficient;
        product.cod_fonte_dati = this.cod_fonte_dati;
        product.sco_fonte_dati = this.sco_fonte_dati;
        product.fg_valido_inizio = this.fg_valido_inizio;
        product.fg_valido_fine = this.fg_valido_fine;
        product.id_atto_inizio = this.id_atto_inizio;
        product.id_atto_fine = this.id_atto_fine;
        product.dt_ultimo_agg = this.dt_ultimo_agg;
        product.utente = this.utente;
        return product;
    }
}

export class StandardOutputs {
    @Type(() => StandardOutput)
    standardOutputs: StandardOutput[] = [];
    dynamicString!: string;

    @Exclude()
    get isValid(): string[] {
        const isValid = this.standardOutputs.map((q, i) => q.isValid.map(e => `standardOutputs.${i}.${e}`)).flat();
        return [...isValid];
    }

    @Exclude()
    get totSO(): number {
        return Utils.sum(this.standardOutputs.map(e => e.so_value || 0));
    }
}
export class LocationInvestmentParcels {
    elements!: Parcel[];
    totalArea!: number;
    totalArableArea!: number;
    totalPermanentArea!: number;
    techincalDescritionChoice!: string;
}

export class Parcel {
    applied!: boolean;
    parcelId!: number;
    nationalCode!: string;
    sheet!: number;
    parcel!: string;
    sheetLabel!: string;
    osSheetNumber!: string;
    area!: number;
    arableArea!: number;
    permanentArea!: number;
    parcelFullCode!: string;
}

export class DownloadFileParams {
    mime_type!: string;
    extension!: string;
}

